/** Multiple custom tracking domains — English (structure pinned to fr). */
import type { TrackingDomainsKeys } from './fr';

const trackingDomainsEn: TrackingDomainsKeys = {
  title: 'Custom tracking domains',
  description:
    'Open, click and unsubscribe links use the domain assigned to the sending identity, otherwise the default domain, otherwise the platform domain.',
  unavailable: 'Tracking domains are not available on this environment yet.',
  loadError: 'Could not load the tracking domains.',
  addTitle: 'Add a tracking domain',
  domainLabel: 'Domain',
  domainHint: 'Without http(s)://, e.g. track.yourdomain.com',
  domainPlaceholder: 'track.acme.com',
  schemeLabel: 'Scheme',
  schemeHttps: 'HTTPS',
  schemeHttp: 'HTTP',
  dkimLabel: 'DKIM selector',
  dkimHint: 'Optional — replaces the default selector for the identities using this domain',
  dkimPlaceholder: 'e.g. s1',
  makeDefault: 'Make it the default domain',
  add: 'Add',
  adding: 'Adding…',
  empty: 'No custom tracking domain yet — links use the platform domain.',
  defaultBadge: 'Default',
  statusPending: 'Not checked',
  statusVerified: 'Verified',
  statusFailed: 'Verification failed',
  lastChecked: 'Last checked: {{date}}',
  verify: 'Verify',
  verifying: 'Checking…',
  setDefault: 'Make default',
  edit: 'Edit',
  save: 'Save',
  saving: 'Saving…',
  cancel: 'Cancel',
  delete: 'Delete',
  deleteTitle: 'Delete this tracking domain?',
  deleteMessage: '{{domain}} will be removed. Identities using it fall back to the default domain.',
  assign: 'Assign identities',
  assignTitle: 'Identities using {{domain}}',
  assignHint: 'Connected mailboxes send through their linked identity, so they follow the same domain.',
  noIdentities: 'No sending identity yet.',
  assignedCount: 'Assigned identities: {{count}}',
  usesDefault: 'Identities that are not assigned use the default domain.',
  currentlyOn: 'currently on {{domain}}',
  publishCname: 'Publish this CNAME record:',
  recordType: 'Type',
  recordHost: 'Host',
  recordValue: 'Value',
  cnameOk: 'The CNAME correctly points to {{target}}.',
  errExists: 'This domain is already configured.',
  errOverLimit:
    'This domain is over your plan limit: it is read-only. Upgrade or delete domains to edit it.',
  errInvalid: 'Enter a fully-qualified host name such as track.example.com.',
  errGeneric: 'The operation failed.',
  created: 'Domain {{domain}} added.',
  deleted: 'Domain {{domain}} deleted.',
  defaultSet: '{{domain}} is now the default domain.',
  saved: 'Changes saved.',
  assignedSaved: 'Assignment saved.',
};

export default trackingDomainsEn;
